<template>
  <div class="page-container">
    <div class="query-title">销售计划批导查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <!-- <table-button v-for="btn in gridOptions.buttons" :key="btn.label" :name="btn.icon" :tip="btn.label" @click="tableEvent(btn)" /> -->
            <!-- 导入 -->
            <el-dropdown @command="tableEvent">
              <div><table-button name="import" tip="导入" /></div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in gridOptions.buttons"
                  :key="item.type"
                  :command="{
                    icon: 'import',
                    type: item.type,
                    key: item.key
                  }"
                >{{ item.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- 下载 -->
            <el-dropdown @command="tableEvent">
              <div><table-button name="download" tip="模版下载" /></div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in gridOptions.buttons"
                  :key="item.type"
                  :command="{
                    icon: 'download',
                    type: item.type,
                    fileName:item.fileName
                  }"
                >{{ item.fileName }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #batch_number="{ row }">
              <span class="blue" @click="toDetail(row)">{{ row.batch_number }}</span>
            </template>
            <template #file_name="{ row }">
              <span class="blue" @click="downLoadFile(row)">{{ row.file_name }}</span>
            </template>
            <template #uzeit="{row}">
              <span>{{ formatTime(row.uzeit) }}</span>
            </template>
            <template #datum="{row}">
              <span>{{ formatDate(row.datum) }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { apiSaleImportList, apiSaleImportBatchCheck, apiSaleComImportBatchCheck } from '@/api/sap/sale-plan'
import {
  apiExcelImport,
  apiGetExcelImportData,
  apiExportExcelTemplate,apiFindAttachId
} from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { sapDownloadFile } from '@/utils/frontExport'

import tableMixins from '@/utils/tableMixins'
import pageConfig from '../config/BatchQuery'
import { mapGetters } from 'vuex'

import { download } from '@/utils/frontExport'
import { apiAttachmentDownFile } from '@/api/common'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      batchConditions: {
        batchNumber: '',
        templateCode: ''
      },
      orderPlanIds: '',
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        buttons: [
          {
            label: '销售计划单新增批导',
            fileName: '销售计划单新增批导模版',
            icon: 'import',
            key: 'V001',
            type: 'orderPlan'
          },
          {
            label: '销售计划单变更批导',
            fileName: '销售计划单变更批导模版',
            icon: 'import',
            key: 'V002',
            type: 'orderPlanChange'
          },
          {
            label: '销售计划(公司/营销单元)批导',
            fileName: '销售计划单(公司/营销单元)批导模版',
            icon: 'import',
            key: 'V003',
            type: 'orderCompanyPlan'
          },
          {
            label: '销售计划(公司/营销单元)变更批导',
            fileName: '销售计划(公司/营销单元)变更批导模版',
            icon: 'import',
            key: 'V004',
            type: 'orderCompanyPlanChange'
          }
        ],
        columns: [],
        data: []
      },
      // pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    const params = { bizCode: 'orderPlan,orderPlanChange,orderCompanyPlan,orderCompanyPlanChange' }
    apiFindAttachId(params).then(response => {
      this.orderPlanIds = response.data
    })
    this.initPage(pageConfig)
  },
  methods: {
    // 格式化时间
    formatTime(time) {
      return time.replace(/^(\d{2})(\d{2})(\d{2})$/, '$1:$2:$3')
    },
    formatDate(date) {
      return date.replace(/^(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
    },
    downLoadFile(row) {
      sapDownloadFile(row.file_data, row.file_name)
    },
    toDetail(row) {
      this.$emit('change-action', 'batch', row.batch_number)
    },
    async uploadFile(file, cb) {
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')
        cb(strArr)
      }
    },
    // 导入excel
    async handleImportExcel(type, btn) {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: type
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.batchConditions.batchNumber = res.data
            this.batchConditions.templateCode = type
            this.handleQueryImportExcel(files, btn)
          }
        })
    },
    // 根据批次号查询数据
    async handleQueryImportExcel([...files], btn) {
      const params = {
        ...this.batchConditions,
        page: 1,
        pagesize: 1000
      }

      const { data } = await apiGetExcelImportData(params)
      // 转换一哈驼峰
      for (const item of data.Rows) {
        // 转换大小写
        Object.keys(item).forEach(key => {
          item[this.toLineAndUp(key)] = item[key]
          if (this.toLineAndUp(key) !== key) {
            delete item[key]
          }
        })
      }
      this.uploadFile(files[0], async filedata => {
        // 是否是新增
        const isCrt = ['V001', 'V003'].includes(btn.key)
        // 是否是公司/营销单元
        const isCom = ['V003', 'V004'].includes(btn.key)
        const params2 = {
          gs_batch_type: btn.key,
          user_bp: this.role.USER_BP,
          head: {
            file_name: files[0].name,
            file_data: filedata
          },
          [isCrt ? 'crt_head' : 'chg_head']: data.Rows
        }
        const res = isCom ? await apiSaleComImportBatchCheck(params2) : await apiSaleImportBatchCheck(params2)
        if (res.msgtype === 'E') {
          return this.$message.error(res.message)
        }
        res.data && this.$emit('change-action', 'batch', res.data)
      })
    },
    // 驼峰转成下划线
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toLowerCase()
    },
    // 模板下崽
    async downloadTemplate({ type, fileName }) {
      // alert("测试中。。。BatchQuery=="+type+":="+ this.orderPlanIds)
      let attachId=''
      if (this.orderPlanIds.indexOf(',') !== -1) {
        const txtArr = this.orderPlanIds.split(',')
        for (var i = 0; i < txtArr.length; i++) {
          const strArr = txtArr[i].split(':')
          if (strArr[1]===type) {
            attachId= strArr[0]
          }
        }
      }
     // alert(attachId)
      if (type === 'orderPlan') {
         fileName = '销售计划单新增批导模版.xlsx'
      //  const params = { bizCode: type }
        //apiFindBizId(params).then(response => {
        /*  const params = { id: '10e25c7ddabf494486a6b040fbdcce3c' }
          console.log('========params=========',params)
          apiAttachmentDownFile(params).then(res => {
            console.log('======res===========', res.data)
            download(res.data, fileName)
          })
          */


        const res = apiAttachmentDownFile({ id: this.orderPlanBizId })


        fileName = '销售计划单新增批导模版.xlsx'
      } else if (type === 'orderPlanChange') {
        fileName = '销售计划单变更批导模版.xlsx'
      } else if (type === 'orderCompanyPlan') {
        fileName = '销售计划单(公司_营销单元)批导模版.xlsx'
      } else if (type === 'orderCompanyPlanChange') {
        fileName = '销售计划(公司_营销单元)变更批导模版.xlsx'
      }
        const res = await apiAttachmentDownFile({ id: attachId })

        download(res.data, fileName)
      //  })
     // } else {   //orderPlanChange   orderCompanyPlan   orderCompanyPlanChange

      /*  const res = await apiExportExcelTemplate(type)
         if (res?.status !== 0) {
           return
         }

        const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${res.data.file}&authToken=${getToken()}&fileName=${fileName}`
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.target = '_blank'
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)*/
     // }
    },
    // 导出表格
    async exportExcel() {
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiSaleImportList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 按钮事件
    tableEvent(btn) {
      switch (btn.icon) {
        case 'import':
          this.handleImportExcel(btn.type, btn)
          break
        case 'download':
          this.downloadTemplate(btn)
          break
        case 'export':
          this.exportExcel()
          break
      }
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/BatchQuery.vue